import { createSystem, defaultConfig, defineConfig } from "@chakra-ui/react";

const config = defineConfig({
    globalCss: {
        "html, body": {
            fontFamily: "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif",
            lineHeight: 1.6,
        },
        "*::selection": {
            bg: "rgba(66, 133, 244, 0.2)",
        },
    },
    theme: {
        tokens: {
            fontSizes: {
                "xx-small": { value: "8px" },
                "x-small": { value: "10px" },
                small: { value: "12px" },
                medium: { value: "14px" },
                large: { value: "16px" },
                larger: { value: "18px" },
                "x-large": { value: "24px" }
            },
            fonts: {
                heading: { value: "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif" },
                body: { value: "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif" },
            },
        },
    },
});

const themeSystem = createSystem(defaultConfig, config);

export default themeSystem;
